import type { AreaCatalog } from '../area';
import type { notes as en } from '../en/notes';

export const notes = {
  'notes.refusal.malformedCitation': 'Der Verweis auf die Aussage ist fehlerhaft.',
  'notes.refusal.notItsItem':
    'Eine Notiz gehört zur Aussage bei ihrer eigenen Aufgabe. Wirkt eine andere Aufgabe auf deine Zusage, setze einen Zustand mit Verweis auf die Aussage, oder sage, dass deine Aufgabe nicht betroffen ist.',
  'notes.refusal.empty': 'Die Notiz ist leer.',
  'notes.refusal.tooLong': 'Eine Notiz zu einer Aussage hat höchstens {max} Zeichen.',
} as const satisfies AreaCatalog<typeof en>;
